// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab[data-v-2d00c438]{background-color:var(--c-light-gray);cursor:pointer;height:50px;line-height:20px;max-width:200px;min-width:40px;padding:15px}.tab--active[data-v-2d00c438]{background-color:var(--c-white)}.tab__name[data-v-2d00c438]{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
